<script lang="ts">const defaultFill = "#ffffff";
const hoverFill = "#BAE6FD";
let fill = defaultFill;
export let width = 24;
export let height = 25;
export let className = "";
</script>

<!-- svelte-ignore a11y-no-static-element-interactions -->
<svg
	{fill}
	{width}
	{height}
	version="1.1"
	class={className}
	xmlns="http://www.w3.org/2000/svg"
	x="0px"
	y="0px"
	viewBox="0 0 512 512"
	on:mouseenter={() => (fill = hoverFill)}
	on:mouseleave={() => (fill = defaultFill)}
	><g
		><g
			><path
				d="M368.467,0H47.133c-8.284,0-15,6.716-15,15v385.601c0,8.284,6.716,15,15,15h321.334c8.284,0,15-6.716,15-15V15    C383.467,6.716,376.751,0,368.467,0z"
			/></g
		></g
	><g
		><g
			><path
				d="M464.867,96.4h-51.4v304.2c0,24.814-20.186,45-45,45H128.533V497c0,8.284,6.716,15,15,15h321.334c8.284,0,15-6.716,15-15    V111.4C479.867,103.116,473.151,96.4,464.867,96.4z"
			/></g
		></g
	><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /></svg
>

<style>
	svg {
    height: 0.75rem;
    width: 0.75rem
}
</style>
